(function () {
  'use strict';

  const pageUrl = new URL(window.location);
  const { hash: pageHash } = pageUrl;
  const skipLink = document.getElementById('skip-link-content');
  const header = document.getElementById('header-rebrand');

  const jumpToMainContent = (link) => {
    const skipUrl = new URL(link.href);
    const { hash: skipHash } = skipUrl;
    const anchor = document.querySelector(skipHash);
    if (!header || !anchor) {
      return;
    }

    const headerHeight = header.clientHeight || 0;
    const anchorBox = anchor.getBoundingClientRect();
    const { top: anchorTop } = anchorBox;
    const scrollY = anchorTop - headerHeight;
    window.scrollTo(0, scrollY);

    if (skipHash !== pageHash) {
      const jumpUrl = new URL(window.location);
      jumpUrl.hash = skipHash;
      window.history.pushState({}, '', jumpUrl);
    }
  };

  const handleClickSkipLink = (ev) => {
    ev.preventDefault();
    const link = ev.currentTarget;
    jumpToMainContent(link);
  };

  if (skipLink) {
    skipLink.addEventListener('click', handleClickSkipLink);
  }

  // override <a> functionality to remove "#content-start" on URL
  const skipContentLink = document.querySelectorAll('.js-sqz-skip-link');

  const skipFunctionality = () => {
    skipContentLink.forEach((link) => {
      // href ie currentURL#content-start
      const skipContentLinkhref = link.href;
      const array = skipContentLinkhref.split('#');
      // select anchor element based on the href of the skipContentLink
      const anchorElement = document.querySelector(`#${array[1]}`);
      link.addEventListener('click', function (e) {
        e.preventDefault();
        anchorElement.focus();
        anchorElement.scrollIntoView();
      });
    });
  };
  if (skipContentLink) {
    skipFunctionality();
  }
})();
